import { HttpExtendedService } from './http-extended.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Event } from 'src/app/tools/calendar/models/calendar.model';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class ReservationService {
  private apiUrl: string;

  constructor(private http: HttpExtendedService, config: ConfigService) {
    this.apiUrl = config.config.reservationUrl;
  }

  addReservation(reservation: Event): Observable<Event> {
    return this.http.post<Event>(this.apiUrl, reservation);
  }

  getReservations(): Observable<Event[]> {
    return this.http.get<Event[]>(this.apiUrl);
  }

  updateReservation(reservation: Event): Observable<Event> {
    return this.http.put<Event>(this.apiUrl, reservation);
  }

  deleteReservation(reservation: Event): Observable<Event> {
    return this.http.post<Event>(`${this.apiUrl}/delete`, reservation);
  }
}
